import { render } from "./BarberHome.vue?vue&type=template&id=11db4cea"
import script from "./BarberHome.vue?vue&type=script&lang=js"
export * from "./BarberHome.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__